// extracted by mini-css-extract-plugin
export default {"container":"AllInOne_container__t2pfh","wrapper":"AllInOne_wrapper__anIWk","item":"AllInOne_item__VeYwn","titles":"AllInOne_titles__MSpZk"};